import styled from 'styled-components';

export const OnboardingWelcomePageStyled = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    background-color: var(--color-surface);
`;

export const OnboardingWelcomePageContentStyled = styled.div`
    padding: 24px;
    text-align: center;
    border: 1px solid var(--color-yellow);
    width: 100%;
    margin: 0 auto;
    border-radius: 2px;
    
    em {
        font-style: normal;
        color: var(--color-yellow);
    }

    h3 {
        font-size: 20px;
    }
    
    @media(max-height: 520px) {
        h3 {
            font-size: 16px;
        }
        p {
            font-size: 14px;
        }
    }
`;

export const OnboardingWelcomePageButtonContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 500px;
    margin: 32px auto 0;
`;

export const OnboardingWelcomePageContainerStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
    max-width: 500px;
`;

export const OnboardingHeaderDescriptionStyled = styled.p`
    text-align: center;
    margin: 24px 0;
    
    @media(max-height: 520px) {
        margin: 16px 0;
    }
`;
